import { numberFormatters } from "./number.formatter"

export enum NumberType {
    last_total_etf_btc_usd = 'last_total_etf_btc_usd',
    change_total_7D_btc_etf_native = 'change_total_7D_btc_etf_native',
    change_total_7D_eth_etf_native = 'change_total_7D_eth_etf_native',
    last_total_etf_eth_usd = 'last_total_etf_eth_usd',
    change_total_7D_btc_absolute = 'change_total_7D_btc_absolute',
    change_total_7D_eth_absolute = 'change_total_7D_eth_absolute'
}

export interface NumberOptions {
    format: (price: number) => string
    color?: (price: number) => string
}

const numberColor = (price: number) => price > 0 ? 'var(--green-percentage)' : 'var(--coral)'

export const NumberOptionsMap = new Map<NumberType, NumberOptions>([
    [NumberType.change_total_7D_btc_etf_native,  {
        format: numberFormatters.percent,
        color: numberColor
    }],
    [NumberType.change_total_7D_eth_etf_native,  {
        format: numberFormatters.percent,
        color: numberColor
    }],
    [NumberType.last_total_etf_eth_usd,  {
        format: numberFormatters.largeNumber
    }],
    [NumberType.last_total_etf_btc_usd,  {
        format: numberFormatters.largeNumber
    }],
    [NumberType.change_total_7D_eth_absolute, {
        format: numberFormatters.ethereumPrice, 
        color: numberColor
    }],
    [NumberType.change_total_7D_btc_absolute, {
        format: numberFormatters.bitcoinPrice, 
        color: numberColor
    }]
])